
  import DetailsModule from './DetailsModule.vue'
  import ProfileSvc from "../../../../../services/profile-svc";
  let profileSvc = null;
  export default {
    components: { DetailsModule },
    props: {
      layout: {
        required: false,
        default: 'portal'
      }
    },
    data: () => ({
      noShowAppointment: null,
      loading: false,
      showDialog: false,
    }),
    methods: {
        getFairPayStatus() {
          switch (this.noShowAppointment.fairPayStatus) {
              case 0: return 'UNKNOWN'; 
              case 1: return 'NEW'
              case 2: return 'REMINDER1'
              case 3: return 'REMINDER2'
              case 4: return 'PARDONED'
              case 5: return 'PAID'
              case 6: return 'FEE SENT'
          }
        },
        isCancelled() {
          return this.noShowAppointment.orderHistoryType === 3
        },
        termsLink() {
          var link =
            "https://fixit.no/bedrift/artikler/vilkaar-for-bruk-av-fixitno/";
          return `<a href=${link} target='_blank'>vilkår for bruk</a>`;
        },
  },
  async created() {
    this.loading = true;
    profileSvc = await ProfileSvc(this.$axios);
    let noShows = this.$store.getters['fairpay/getFairPayAppointments']
    if (!noShows.length) {
      await this.$store.dispatch('fairpay/getFairPayAppointmentDetails')
      noShows = this.$store.getters['fairpay/getFairPayAppointments']
    }
    this.noShowAppointment = noShows.find(x => x.base64AppointmentId === this.$route.params.id)
    this.loading = false;
  },
  beforeDestroy() {
    profileSvc = null;
  },
}
  